module.exports = __webpack_public_path__ + "assets/img/nw_info.c89cd448.png";